import API from '@/api'
import popup from './labs/popup.store.js';

export default {
  namespaced: true,
  modules: {
    'popup': popup,
  },
  state: {
    data: [],
    loaded: false,
    lab: [],
    methods: [],
    methodsById: [],
    filters: {
      perPage: 1000,
      page: 1,
      search: ''
    }
  },
  mutations: {
    saveData(state, data) {
      state.data = data;
    },
    load(state) {
      state.loaded = true;
    },
    saveLab(state, data) {
      state.lab = data;
    },
    saveMethods(state, data) {
      state.methods = data;
    },
    saveMethodById(state, data) {
      state.methodsById = data;
    },

    setSearch (state, val) {
      state.filters.search = val;
    }
  },
  actions: {
    loadLabs(context, payload) {
      return API.labs.getLabs(context.state.filters).then(res => {
        context.commit('saveData', res.data.data.data);
        context.commit('load');
      });
    },

    loadAllExt(context, payload) {
      return API.labs.getAllExt().then(res => {
        context.commit('saveMethods', res.data.data.data);
      });
    },

    getLab(context, payload) {
      let data = context.state.data.filter(x => x.id == payload);
      context.commit('saveLab', data[0]);
    },

    getMethods(context, payload) {
      let data = context.state.methods.filter(x => x.methodId == payload);
      context.commit('saveMethodById', data);
    },


  },
  getters: {
    data(state) {
      return state.data;
    },
    lab(state) {
      return state.lab;
    },
    methods(state) {
      return state.methodsById;
    }


  }
}
